import { makeStyles } from '@material-ui/core';

export const useDownloadButtonStyles = makeStyles((theme) => ({
  imageContainer: {
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(1, 0),
    },
  },
  image: {
    position: 'relative',
    height: 'auto',
    backgroundSize: 'cover',
    ['&.sm']: {
      width: 80,
      [theme.breakpoints.up('md')]: {
        width: 100,
      },
    },
    ['&.lg']: {
      width: 130,
    },
  },
  text: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(2),
    color: '#e7e7e7',
    fontWeight: 700,
    fontSize: '0.5rem',
  },
}));
